import { formatMoney } from 'accounting'

import { SidebarModalListItem } from '@domain-group/suit-theme'

import type { CampaignItemModel, OrderModel } from '@models/types'

interface BulkReconcileSubHeaderProps {
  callbacks: {
    toggleId: (arg: number) => void,
  },
  isLastItem: boolean,
  item: CampaignItemModel | OrderModel,
}

const ReconciliationListItem = (props: BulkReconcileSubHeaderProps) => {
  const {
    callbacks: { toggleId }, isLastItem, item,
  } = props

  const {
    // @ts-expect-error TS2339
    id, invoice_total, price_override, title, total,
  } = item

  return (
    <SidebarModalListItem
      boxProps={{ paddingY: 'medium', borderBottom: isLastItem ? 'none' : '1px dotted' }}
      secondaryText={`#${id}`}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.TertiaryText>
        {formatMoney((price_override || total) - (invoice_total || 0))}
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon onClick={() => toggleId(id)} type="delete" />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default ReconciliationListItem
